import React from 'react'

function QuelluetungAllgAus() {
  return (
    <embed src="\pdfs\D1.4.0.2_Quellueftung-Allgemeine_Auslegung_04.2014_kr.pdf" width="100%" height="2100px" />
  )
}

export default QuelluetungAllgAus